<template>
  <b-card :title="$t('users session') | capitalize">
    <filter-slot
      :filter="filters"
      :filter-principal="filterPrincipal"
      :paginate="paginate"
      @reload="$refs['ref-table-sessions-list'].refresh()"
    >
      <template #table>
        <b-table
          ref="ref-table-sessions-list"
          :per-page="paginate.perPage"
          :current-page="paginate.currentPage"
          sticky-header="50vh"
          small
          class="position-relative font-small-3"
          table-class="text-nowrap"
          :busy.sync="isBusy"
          :items="myProvider"
          :fields="fields"
          primary-key="id"
          :empty-text="$t('NO MATCHING RECORDS FOUND')"
        >
          <template #table-busy>
            <div class="text-center text-primary my-2">
              <b-spinner class="align-middle mr-1" />
              <strong v-t="'LOADING...'"></strong>
            </div>
          </template>

          <template #cell(start_session)="data">
            <div class="text-center">
              {{ data.item.start_session | myGlobalDay }}
            </div>
          </template>

          <template #cell(end_session)="data">
            <div class="text-center">
              {{ data.item.end_session | myGlobalDay }}
            </div>
          </template>
        </b-table>
      </template>
    </filter-slot>
  </b-card>
</template>

<script>
import UserService from "@/views/users/views/list/services/users.services.js";
import Fields from "@/views/users/views/list/data/fields-sessions.data.js";
import Filters from "@/views/users/views/list/data/filters-sessions.data.js";
import FilterSlot from "@/views/commons/filter-slot/FilterSlot.vue";

export default {
  name: "UserSessions",
  components: {
    FilterSlot,
  },
  props: {
    user_id: {
      type: [Number, String],
      required: true,
    },
  },
  computed: {
    fields() {
      return Fields.map((element) => ({
        ...element,
        label: this.$t(element.label),
      }));
    },

    filters() {
      return Filters;
    },
  },
  data() {
    return {
      user: {},
      isBusy: false,
      filterPrincipal: {
        type: "input",
        inputType: "text",
        placeholder: "SEARCH...",
        model: "",
      },
      paginate: {
        from: 0,
        to: 0,
        of: 0,
        perPage: 10,
        currentPage: 1,
      },
    };
  },

  methods: {
    async myProvider(ctx) {
      try {
        const params = {
          user_id: this.user_id,
          page: this.paginate.currentPage,
          perpage: this.paginate.perPage,
          order_desc: ctx.sortDesc ? "desc" : "asc",
          search_txt: this.filterPrincipal.model,
          date_from: this.filters[0].model,
          date_to: this.filters[1].model,
        };

        const { data } = await UserService.getUsersSession(params);
        this.paginate.from = data.from;
        this.paginate.to = data.to;
        this.paginate.of = data.total;
        this.paginate.perPage = data.per_page;
        this.paginate.currentPage = data.current_page;
        return data.data || [];
      } catch (e) {
        console.log(e);
      }
    },
  },
};
</script>

<style>
</style>